import React from "react";

const PlusIconSVG = ({ height = "18", width = "18", fill = "white" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.95837 10H15.0417"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 4.45833V15.5417"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlusIconSVG;
